import gql from 'graphql-tag.macro';

export const query = gql`
  query getImportedDrafts(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $filter: ImportedDraftsFilter!
  ) {
    importedDrafts(
      first: $first
      last: $last
      after: $after
      before: $before
      filter: $filter
    ) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          id
          requestName
          startDate
          totalDuration
        }
      }
    }
  }
`;

const reducer = (payload) => ({
  nodes: payload.importedDrafts.edges.filter(edge => edge !== null).map(({ node }) => node),
  ...payload.importedDrafts
});

export const getImportedDrafts = {
  reducer,
  query,
  paginated: true,
};
